<script lang="ts">
    export let id: string | null = null;
    export let wide = false;
    const animate = false;
</script>

{#if animate}
    <!-- ANIMATION WHEN WE CAN -->
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 154 52">
        <mask id="mask0_11365_40345" style="mask-type:alpha" maskUnits="userSpaceOnUse">
            <path
                d="M0 26C0 11.6406 11.6406 0 26 0H128C142.359 0 154 11.6406 154 26C154 40.3594 142.359 52 128 52H26C11.6406 52 0 40.3594 0 26Z"
                fill="#D9D9D9"
            />
        </mask>
        <g mask="url(#mask0_11365_40345)">
            <rect
                opacity="0.5"
                width="20.6527"
                height="210.406"
                transform="matrix(0.759489 0.65052 -0.759489 0.65052 90.4504 -107.456)"
                fill="white"
            />
        </g>
    </svg>
{/if}
<div class="h-xl desktop-l:h-[52px]">
    <div
        {id}
        class=":not(active:)pb-[2px] cursor-pointer select-none transition-all active:pt-[2px]"
    >
        <div
            class="relative box-border h-3xs rounded-full border-b-[6px] border-b-[rgba(0,0,0,0.3)] bg-teal-50 px-sm pb-[20px] pt-sm transition-all desktop-l:px-md desktop-l:pb-[22px] desktop-l:pt-md"
            class:desktop-l:px-lg={!wide}
        >
            <div
                class="fill-current flex h-[inherit] w-full items-center justify-center gap-3xs text-btn font-bold text-purple-80 desktop-l:h-full"
            >
                <slot />
            </div>
        </div>
    </div>
</div>

<style lang="postcss">
    svg {
        @apply h-xl w-[134px] desktop-l:h-[52px] desktop-l:w-[154px];
        animation: shine 200ms ease-out infinite forwards;
    }

    @keyframes shine {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(100%);
        }
    }
</style>
